import { Breadcrumb } from 'antd'
import { ArrowRight2 } from 'iconsax-react'
import { useJobVacancyApplicants } from './hooks/useJobVacancyApplicants'
import { useJobVacancyDetail } from './hooks/useJobVacancyDetail'
import JobVacancyDetailCard from './components/JobVacancyDetailCard'
import JobVacancyApplicantsCard from './components/JobVacancyApplicantsCard'
import ItemRender from 'components/breadcrumb/ItemRender'
import { jobVacancyDetailItems } from 'constants/breadcrumb/items'
import ModalUpdateApplicantStatus from './components/ModalUpdateApplicantStatus'
import ModalUpdateJobVacancyStatus from './components/ModalUpdateJobVacancyStatus'

export default function JobVacancyDetail() {
  const useJobDetail = useJobVacancyDetail()
  const useJobApplicants = useJobVacancyApplicants()

  return (
    <div className="content-wrapper">
      <div>{useJobDetail.toastContainer}</div>
      <div>{useJobApplicants.toastContainer}</div>
      <Breadcrumb
        className="pb-6"
        itemRender={route => ItemRender(route)}
        items={jobVacancyDetailItems}
        separator={<ArrowRight2 size="12" color="#868C94" />}
      />
      <JobVacancyDetailCard
        fetchStatusJobVacancyDetail={useJobDetail.fetchStatusJobVacancyDetail}
        jobVacancy={useJobDetail.jobVacancy}
        fetchJobVacancy={useJobDetail.fetchJobVacanyDetail}
        onEditJobVacancy={useJobDetail.handleOnEditJobVacancy}
        onOpenModalUpdateJobVacancyStatus={useJobDetail.handleOnOpenModalUpdateJobVacancyStatus}
      />
      <div className="my-3" />

      <JobVacancyApplicantsCard
        fetchJobApplicants={useJobApplicants.fetchJobApplicants}
        fetchStatusJobApplicants={useJobApplicants.fetchStatusJobApplicants}
        selectedStatusJobApplicants={useJobApplicants.selectedStatusJobApplicants}
        onChangeSelectedStatusJobApplicants={
          useJobApplicants.handleOnChangeSelectedStatusApplicants
        }
        applicants={useJobApplicants.jobVacancyApplicants}
        pageApplicants={useJobApplicants.pageJobApplicants}
        onChangePageApplicants={useJobApplicants.handleOnChangePageJobVacancyApplicants}
        limitApplicants={useJobApplicants.limitJobApplicants}
        onChangeLimitApplicants={useJobApplicants.handleOnChangeLimitJobVacancyApplicants}
        totalPageApplicants={useJobApplicants.totalPageJobApplicants}
        summary={useJobApplicants.summaryJobApplicants}
        columnsSortBy={useJobApplicants.sortDirectionJobApplicants}
        columnsSortField={useJobApplicants.sortFieldJobApplicants}
        onSort={useJobApplicants.handleOnChangeSort}
        onOpenModalUpdateApplicantStatus={useJobApplicants.handleOnOpenModalUpdateApplicantStatus}
      />
      <ModalUpdateApplicantStatus
        isOpen={useJobApplicants.isModalUpdateApplicantStatusVisible}
        nextApplicantStatus={useJobApplicants.nextApplicantStatus}
        onCancel={useJobApplicants.handleOnCancelModalUpdateApplicantStatus}
        onConfirm={useJobApplicants.handleOnUpdateApplicantStatus}
        fetchStatusUpdateJobApplicant={useJobApplicants.fetchStatusUpdateJobApplicant}
      />
      <ModalUpdateJobVacancyStatus
        fetchStatusUpdateJobVacancy={useJobDetail.fetchStatusUpdateJobVacancyStatus}
        isOpen={useJobDetail.isModalUpdateJobVacancyStatusVisible}
        onCancel={useJobDetail.handleOnCancelModalUpdateJobVacancyStatus}
        onConfirm={useJobDetail.handleOnUpdateJobVacancyStatus}
      />
    </div>
  )
}
